import { ReactNode, useId } from 'react'

interface ComponentsProps {
  element: ReactNode
  name?: string
}

interface Props {
  components?: ComponentsProps[]
  currentChildIndex: number
  bodyClassName?: string
}

const SliderBody = ({
  currentChildIndex,
  components = [],
  bodyClassName,
}: Props) => {
  const key = useId()
  const classes = [
    'w-full',
    'min-h-[calc(100%_-_56px)]',
    'max-h-[calc(100%_-_56px)]',
    'flex',
    'duration-500',
    'gap-[20px]',
    'box-border',
  ]

  const elementClasses = [
    'min-w-full',
    'w-full',
    'grow',
    'object-cover',
    'flex',
    'overflow-hidden',
    'transition-all',
    'duration-1000',
    bodyClassName,
  ]

  return (
    <div
      className={classes.join(' ')}
      style={{
        transform: `translateX(calc(-${currentChildIndex * 100}% - ${
          currentChildIndex * 20
        }px))`,
      }}
    >
      {components.map((child, index) => (
        <div
          className={`${elementClasses.join(' ')} 
          ${currentChildIndex === index ? 'opacity-100' : 'opacity-0'}`}
          key={key + index}
        >
          {child?.element}
        </div>
      ))}
    </div>
  )
}

export default SliderBody
